import './App.css';
import TopButtons from './Component/TopButtons';
import Inputs from './Component/Inputs';
import TimeAndLocation from './Component/TimeAndLocation';
import TemperatureAndDetails from './Component/TemperatureAndDetails';
import Forecast from './Component/Forecast';
import getFormattedWeatherData from './Services/weatherService';
import { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function App() {




	const [query, setQuery] = useState({ q: 'chennai' })
	const [units, setUnits] = useState('metric')
	const [weather, setWeather] = useState(null)




	useEffect(() => {
		const fetchWeather = async () => {
			const message = query.q ? query.q : "current location"
			toast.info('Fetching Weather for ' + message)
			await getFormattedWeatherData({ ...query, units }).then(data => {
				toast.success(`Successfully fetched weather for ${data.name}, ${data.country}`)
				setWeather(data)
				console.log(data)
			})

		}

		fetchWeather()
	}, [query, units])


	const formatBackground = () => {
		if (!weather) return "from-cyan-700 to-blue-700"
		const threshold = units === 'metric' ? 20 : 60

		if (weather.temp <= threshold) return "from-cyan-700 to-blue-700"

		return "from-yellow-700 to-orange-700"
	}


	return (
		<div className={`mx-auto max-w-screen-md mt-4 py-5 px-28 bg-gradient-to-br h-fit shadow-xl text-white  ${formatBackground()}`}>
			<TopButtons setQuery={setQuery} />
			<Inputs setQuery={setQuery} units={units} setUnits={setUnits} />

			{
				weather && (
					<>
						<TimeAndLocation weather={weather} />
						<TemperatureAndDetails weather={weather} />
						<Forecast title="hourly forecast" items={weather.hourly} />
						<Forecast title="daily forecast" items={weather.daily} />
					</>
				)
			}

			<ToastContainer autoClose={2000} theme='colored' newestOnTop={true} />



		</div>
	);
}

export default App;
